export const ASSETS_HOST = "https://assets.roaring.io";
export const ALLOWED_COUNTRIES = ["se", "no", "dk", "fi", "es"];
export const ROARING_FONTS = [
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Segoe UI Variable Text",
  "system-ui",
  "ui-sans-serif",
  "Roboto",
  "Helvetica",
  "Arial",
  "sans-serif",
  "Apple Color Emoji",
  "Segoe UI Emoji",
  "Segoe UI Symbol",
].join(",");

export const LANGUAGES: Array<Language> = ["sv", "en", "no", "da", "fi"];
export const DRAWER_WIDTH = 280;
export const DRAWER_WIDTH_SMALL = 58;
export const LOCALES_LANGUAGES: Array<Language> = ["en", "sv", "no", "da"];

export const DEFAULT_LOCALES: Locale = LANGUAGES.reduce(
  (map, e) => ({ ...map, [e]: { name: "", description: "" } }),
  {} as Locale
);

export const priceStepCostMultiplier = 10000;
